import { Directive, ElementRef, Input, OnInit, Renderer } from '@angular/core';

@Directive({
  selector: '[puiTooltip]'
})
export class PuiTooltipDirective implements OnInit {

  @Input('puiTooltip') tooltip: string;

  constructor(private el: ElementRef, private renderer: Renderer) {
  }

  ngOnInit() {
    if (this.tooltip) {
      this.renderer.setElementAttribute(this.el.nativeElement, 'title', this.tooltip);
    }
  }
}
